export enum UserActivitySource {
    HEAP = 'heap',
    MALOUAPP = 'malouapp',
}

export enum UserActivityType {
    ADD_BUSINESS = 'add_business',
    ANSWER_REVIEW = 'answer_review',
    ANY_KEY_TASK = 'any_key_task',
    BOOSTERS_REQUEST = 'boosters_request',
    CLICK = 'click',
    PUBLISH_RS_POSTS = 'publish_rs_posts',
    SCROLL_ROI_PAGE = 'scroll_roi_page',
    SESSION = 'session',
    STORE_LOCATOR_REQUEST = 'store_locator_request',
    UPDATE_ATTRIBUTES = 'update_attributes',
    UPDATE_DESCRIPTIONS = 'update_descriptions',
    UPDATE_GENERAL_INFOS = 'update_general_infos',
    UPDATE_HOURS = 'update_hours',
    VIEW_AGGREGATED_BOOSTERS_PAGE = 'view_aggregated_boosters_page',
    VIEW_AGGREGATED_EREPUTATION_PAGE = 'view_aggregated_ereputation_page',
    VIEW_AGGREGATED_STATISTICS_BOOSTERS_PAGE = 'view_aggregated_statistics_boosters_page',
    VIEW_AGGREGATED_STATISTICS_EREPUTATION_PAGE = 'view_aggregated_statistics_ereputation_page',
    VIEW_AGGREGATED_STATISTICS_RS_PAGE = 'view_aggregated_statistics_rs_page',
    VIEW_AGGREGATED_STATISTICS_SEMANTIC_ANALYSIS_PAGE = 'view_aggregated_statistics_semantic_analysis_page',
    VIEW_AGGREGATED_STATISTICS_SEO_PAGE = 'view_aggregated_statistics_seo_page',
    VIEW_STATISTICS_BOOSTERS_PAGE = 'view_statistics_boosters_page',
    VIEW_STATISTICS_EREPUTATION_PAGE = 'view_statistics_ereputation_page',
    VIEW_STATISTICS_PAGE = 'view_statistics_page',
    VIEW_STATISTICS_RS_PAGE = 'view_statistics_rs_page',
    VIEW_STATISTICS_SEMANTIC_ANALYSIS_PAGE = 'view_statistics_semantic_analysis_page',
    VIEW_STATISTICS_SEO_PAGE = 'view_statistics_seo_page',
}
